module.exports = __webpack_public_path__ + "img/container3Logo.3371d6f3.png";